// utils/currency.js
import currencyCodes from '../locale/currency/CurrencyCode.json';

export const getCurrencySymbol = (currency) => {
  const code = currency?.toUpperCase();
  return currencyCodes.Code[code] || 'RM'; // Fallback to USD symbol
};